import api from "./api";

// Create a new note
const createNote = (data) => {
  return api.post("/api/customer-note/create", data);
};

const NoteService = {
  createNote,
};

export default NoteService;
